module.exports = __webpack_public_path__ + "img/3.7c728d16.jpg";